<template>
  <div class="tag-list">
    <a
      v-for="item in items"
      :key="item"
      :href="`/tags/${encodeURIComponent(item)}`"
      class="tag-item"
    >
      {{ item }}
    </a>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  items: string[];
}>();
</script>

<style scoped lang="scss">
@use "../styles/abstracts/breakpoints" as *;

.tag-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 0.375rem;

  @include sm {
    gap: 0.5rem;
  }
}

.tag-item {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.6rem;
  border: 1px solid var(--color-text-base);
  font-weight: 500;
  color: var(--color-text-base);
  white-space: nowrap;
  text-transform: lowercase;
  font-size: var(--font-size-xs);
  letter-spacing: 0.02em;
  text-decoration: none;
  transition: all 0.2s ease;

  @include sm {
    font-size: var(--font-size-sm);
    padding: 0.25rem 0.75rem;
  }
}

.tag-item:hover {
  background: var(--color-text-base);
  color: var(--color-background);
}
</style>
